import gql from 'graphql-tag';
import { kmsClient } from '../../apollo';
import { useMutation } from '@apollo/react-hooks';
import { SyncFacebookPagesMutation } from './__generated__/SyncFacebookPagesMutation';

const SYNC_FACEBOOK_PAGES_MUTATION = gql`
  mutation SyncFacebookPagesMutation {
    syncFacebookPages {
      success
      errors
    }
  }
`;

export const useSyncFacebookPagesMutation = () => {
  return useMutation<SyncFacebookPagesMutation>(SYNC_FACEBOOK_PAGES_MUTATION, { client: kmsClient });
};
